var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_995_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.752 0 0 10.752 0 24C0 37.248 10.752 48 24 48C37.248 48 48 37.248 48 24C48 10.752 37.248 0 24 0ZM24 7.2C27.984 7.2 31.2 10.416 31.2 14.4C31.2 18.384 27.984 21.6 24 21.6C20.016 21.6 16.8 18.384 16.8 14.4C16.8 10.416 20.016 7.2 24 7.2ZM24 41.28C18 41.28 12.696 38.208 9.6 33.552C9.672 28.776 19.2 26.16 24 26.16C28.776 26.16 38.328 28.776 38.4 33.552C35.304 38.208 30 41.28 24 41.28Z",
    fill: "#C4CCD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_995_2721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e9b0508abc2bb5f6e60953503b046a7e.svg";
export { ForwardRef as ReactComponent };